import Icon from "components/Elements/Icon/Icon.tsx";
import React, { useEffect, useState } from "react";
import ShareFormModal from "../Modals/ShareFormModal";
import { listViews } from "../../Helpers/JsonLists.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import { Toggle } from "components/Elements/Toggle/Toggle";
import useMediaQueries from "hooks/useMediaQueries";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import { UserLoggedInSection } from "components/Reusable/UserNavigatorMenu/UserLoggedInSection";
import Signup from "components/Structure/Signup/Signup";
import config from "config";
import EmbedConfirmMailModal from "components/Reusable/JUMBOform/Modals/EmbedConfirmMailModal";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal";
import "./EditEmbedPageHeader.scss";
import { useUser } from "contexts/userContext/userContext";
import { useModal } from "contexts/modalContext/modalContext";
import { removeLocalStorage } from "utils/globalLocalStorage.js";

const Header = ({
  pageMode,
  setPageMode,
  userNamePage,
  setViewType,
  viewType,
  FullDetailsEmbedPage,
  titlePage,
  backgroundImageListURLS,
  isAnonymouse = null,
  demoPageId = null,
}) => {
  const { newTabletCondition } = useMediaQueries();

  const { addToast } = useToasts();
  const { getTextByKey, getPath, getLanguage } = useContent();
  const { setModal } = useModal();
  const { getUserData, isLoggedIn } = useUser();
  const userData = getUserData();
  const [isPublished, setIsPublished] = useState(null);

  useEffect(() => {
    renderHeader();
  }, [pageMode]);

  useEffect(() => {
    if (
      FullDetailsEmbedPage &&
      FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageStatusMode
    ) {
      if (
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageStatusMode !== "draft"
      ) {
        setIsPublished(true);
      } else {
        setIsPublished(false);
      }
    } else {
      setIsPublished(true);
    }
  }, [FullDetailsEmbedPage]);

  const renderHeader = () => {
    return pageMode === "first"
      ? previewMode
      : pageMode === "edit"
      ? editModeContainer
      : pageMode === "preview"
      ? previewMode
      : null;
  };

  const handleClickEditButton = () => {
    if (!isLoggedIn()) {
      //after response of login modal, if user is logged in, create personal page
      setModal({
        modal: Signup,
        modalSize: "full-modal",
        props: {
          callback: (res) => {
            callBackLogin(res);
          },
        },
      });
    } else if (userData.UserId !== 809057 && isAnonymouse) {
    } else {
      setPageMode("edit");
    }
  };

  const publishPage = async () => {
    if (userData.IsConfirm) {
      let publishAlert = getTextByKey("publish-embed-page-success");
      if (isPublished) {
        publishAlert = getTextByKey("unpublish-embed-page-success");
      }
      setIsPublished((prev) => !prev);
      const parameters = {
        embedPageUserName: userNamePage,
      };

      const response = await apiRequest(
        "EmbedDynamics",
        "ReactPublishEmbedPage",
        parameters
      );
      if (response.status === "success") {
        if (response.data && response.data === 1) {
          addToast(getTextByKey(publishAlert), {
            appearance: "success",
          });
        }
      }
    } else {
      setModal(() => <EmbedConfirmMailModal />);
    }
  };

  //Preview mode header

  const getEmbedPageUserName = async () => {
    const response = await apiRequest("EmbedDynamics", "GetEmbedPageUserName");
    if (response.status === "success") {
      if (response.data) {
        removeLocalStorage("proccessSignUpEmbedPage");
        window.location.href = `${config.baseurl}${getPath()}page-edit/${
          response.data
        }?mode=edit`;
      } else {
        createPersonalPage();
      }
    }
  };

  const createPersonalPage = async () => {
    const parameters = {
      demoPageId: demoPageId,
      ShortCulture: getLanguage(),
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CreateEmbedPageAfterAnonLogin",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.EmbedDybamicPageResponseCode === 0) {
          if (response.data.UserName) {
            removeLocalStorage("proccessSignUpEmbedPage");
            const baseUrl = config.baseurl.includes(":3000")
              ? config.baseurl.replace("https", "http")
              : config.baseurl;
            const personalPage = `${baseUrl}${getPath()}page-edit/${
              response.data.UserName
            }?mode=edit`;
            window.location.href = personalPage;
          }
        }
      }
    }
  };

  const callBackLogin = (res) => {
    if (res !== undefined) {
      if (!res.IsRegistered) {
        if (res.UserData && res.UserData.UserId) {
          getEmbedPageUserName();
        }
      } else {
        createPersonalPage();
      }
    }
  };

  const openShareModal = () => {
    if (!isLoggedIn()) {
      setModal({
        modal: Signup,
        modalSize: "full-modal",
        props: {
          callback: (res) => {
            callBackLogin(res);
          },
        },
      });
    } else {
      //check if user is confirm
      if (isPublished) {
        setModal(() => (
          <ShareFormModal
            titlePage={titlePage}
            userName={userNamePage}
            backgroundImageListURLS={backgroundImageListURLS}
          />
        ));
      } else {
        //check if user is confirm
        if (userData.IsConfirm) {
          setModal(() => (
            <EmbedLimitOptionsModal
              typeOfModal={"before-share-need-active-page"}
            />
          ));
        } else {
          setModal(() => <EmbedConfirmMailModal />);
        }
      }
    }
  };

  const previewMode = (
    <div className="preview-mode">
      <div className="preview-type">
        <span>{getTextByKey("personal-pages-live-title")}</span>
        <div className="view-type">
          {listViews.map((item, i) =>
            newTabletCondition && item === "desktop" ? (
              <div
                key={i}
                onClick={() => {
                  setViewType(item);
                }}
                className={`view-type-div ${viewType === item ? "active" : ""}`}
              >
                <Icon name="tablet" />
              </div>
            ) : newTabletCondition && item === "tablet" ? (
              <></>
            ) : (
              <div
                key={i}
                onClick={() => {
                  setViewType(item);
                }}
                className={`view-type-div ${viewType === item ? "active" : ""}`}
              >
                <Icon name={item} />
              </div>
            )
          )}
        </div>
      </div>
      <div className="right-preview">
        <div
          className="preview-edit"
          id="page-edit_enter-edit-mode"
          onClick={() => handleClickEditButton()}
        >
          <Icon name="pencil-alt-solid" />
          <span>{getTextByKey("edit-button-personal-page")}</span>
        </div>
        <Tooltip
          id={"share-embed-page-tooltip-preview"}
          tooltipTextKey="share-embed-page-tooltip"
          //hardPositioned
          bottom
        >
          <div
            id="page-edit_enter-share-modal"
            className="share-edit"
            onClick={() => openShareModal()}
          >
            <Icon name="share" />
            <span>{getTextByKey("share-button-personal-pages")}</span>
          </div>
        </Tooltip>
      </div>
    </div>
  );

  //Edit mode header
  const editModeContainer = (
    <div className="edit-mode">
      <div className="title-edit">
        <h1>{getTextByKey("personal-page-header-edit-title")}</h1>
      </div>
      <div className="right-edit">
        <div className="right-edit-tour">
          <div
            id="page-edit_enter-preview-mode"
            className="preview-edit"
            onClick={() => setPageMode("preview")}
          >
            <Icon name="eye-light" />
            <span>{getTextByKey("preview-button-personal-pages")}</span>
          </div>
          <Tooltip
            id={"share-embed-page-tooltip-edit"}
            tooltipTextKey="share-embed-page-tooltip"
            //hardPositioned
            bottom
          >
            <div
              id="page-edit_enter-share-modal"
              className="share-edit"
              onClick={() => openShareModal()}
            >
              <Icon name="share" />
              <span>{getTextByKey("share-button-personal-pages")}</span>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );

  return (
    <div className="header-page">
      <div
        className={`active-page-header ${
          pageMode === "edit" ? "display" : "hide"
        }`}
      >
        <Tooltip
          id={"active-website-tooltip"}
          tooltipTextKey="active-website-tooltip"
          //hardPositioned
          end
        >
          <div className="toggle-page-container">
            <div className="toggle-icon">
              <Toggle status={isPublished} setStatus={publishPage} />
            </div>
            <div className="toggle-text">
              <span>{getTextByKey("active-website")}</span>
            </div>
          </div>
        </Tooltip>
      </div>
      {renderHeader()}
      {isLoggedIn() && (
        <div className="user-menu-embedpage">
          <UserLoggedInSection isCreateForm={true} />
        </div>
      )}
    </div>
  );
};

export default Header;
